import config from "../../../_config/config";
import axiosInstance from "../../../_helpers/axiosInstance";
import { oneSignalConstants } from "../../_constants";
import OneSignalReact from "react-onesignal";

export const set_onesignal_device_token_for_notification_action =
  (data) => async (dispatch) => {
    dispatch({
      type: oneSignalConstants.SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_REQUEST,
    });
    try {
      const deviceId = await OneSignalReact.getUserId((id) => {
        return id;
      });
      await dispatch({
        type: oneSignalConstants.SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_SUCCESS,
        payload: deviceId,
      });
    } catch (e) {
      dispatch({
        type: oneSignalConstants.SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

export const regsiter_onesignal_client_token_for_notification_action =
  (data) => async (dispatch) => {
    dispatch({
      type: oneSignalConstants.REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.oneSignal.oneSignalRegister,
        data
      );
      if (response.status === 200) {
        await dispatch({
          type: oneSignalConstants.REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: oneSignalConstants.REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
